import gql from "graphql-tag";

const annualLeaveYearReturn = `
id
year
total
used
unused
original
totalWorkingHoursPerDay
`;

const getAllEmployeeAnnualLeaveYear = gql`
  query(
    $limit: Int
    $page: Int
    $year: Int
    $employeeIds: [ID!]!
  ) {
    getAllEmployeeAnnualLeaveYear(
      paging: { limit: $limit, page: $page }
      year: $year
      employeeIds: $employeeIds

    ) {
      ${annualLeaveYearReturn}
    }
  }
`;

const getEmployeeAnnualLeaveYear = gql`
  query(
    $id: ID!
  ) {
    getEmployeeAnnualLeaveYear(
      id: $id

    ) {
      ${annualLeaveYearReturn}
    }
  }
`;

const createEmployeeAnnualLeaveYear = gql`
mutation(
    $total: Float 
    $original: Float 
    $used: Float $unused: Float $year: Int! $totalWorkingHoursPerDay: Float $employeeId: ID!
  ) {
    createEmployeeAnnualLeaveYear(
        data: {
            total: $total
            original: $original
            used: $used
            unused: $unused
            year: $year
            totalWorkingHoursPerDay: $totalWorkingHoursPerDay
            employeeId: $employeeId
        }
       

    ) {
      ${annualLeaveYearReturn}
    }
  }
`;

const deleteEmployeeAnnualLeaveYear = gql`
  mutation($id: ID!) {
    deleteEmployeeAnnualLeaveYear(id: $id) {
      id
    }
  }
`;

const updateEmployeeAnnualLeaveYear = gql`
mutation(
    $id: ID!
    $total: Float
    $original: Float
    $used: Float $unused: Float $totalWorkingHoursPerDay: Float
  ) {
    updateEmployeeAnnualLeaveYear(
        id: $id
        data: {
            total: $total
            original: $original
            used: $used
            unused: $unused
            totalWorkingHoursPerDay: $totalWorkingHoursPerDay
        }
    ) {
        ${annualLeaveYearReturn}
    }
  }
`;

export default {
  getAllEmployeeAnnualLeaveYear,
  getEmployeeAnnualLeaveYear,
  createEmployeeAnnualLeaveYear,
  deleteEmployeeAnnualLeaveYear,
  updateEmployeeAnnualLeaveYear,
};
